import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Loader, Menu, Message } from 'semantic-ui-react';
import { getCards } from '../../Api/api';
import UserCard from '../../Components/UserCard/UserCard';
import styles from './MainPage.module.css';

interface MainPageProps {
    phone: string;
}

function MainPage(props: MainPageProps) {
    const [loading, setLoading] = useState(true);

    const [cards, setCards] = useState([]);

    useEffect(() => {
        getCards()
            .then((result) => {
                setCards(result);
            })
            .catch((err) => {
                toast.error(err.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <>
            <Menu borderless>
                <Menu.Item
                    header
                    className={styles['menu-item']}
                    name={'Личный кабинет ' + props.phone}
                />
            </Menu>

            <Loader active={loading} />

            <Message>
                <Message.Header>Добро пожаловать!</Message.Header>
                <p>
                    Выберите карту для загрузки в Wallet.
                </p>
            </Message>
            <div className={styles['cards']}>
                {cards.map((card) => <UserCard key={card.uuid} card={card} />)}
            </div>
        </>
    );
}

export default MainPage;